module.exports = __webpack_public_path__ + "img/wapa.b93da796.jpg";